class WaterCostCalculator extends HTMLElement {
  constructor() {
    super();
    this.handleSliderInput = this.handleSliderInput.bind(this);
  }

  connectedCallback() {
    this.slider = this.querySelector('[data-calculator-slider]');

    if (!(this.slider instanceof HTMLInputElement)) return;

    this.outputs = {
      weekly: this.querySelector('[data-current-weekly]'),
      monthly: this.querySelector('[data-monthly-bottles]'),
      waterSupply: this.querySelector('[data-water-supply-cost]'),
      coolerRental: this.querySelector('[data-cooler-rental-cost]'),
      totalSystem: this.querySelector('[data-total-system-cost]'),
      servicedRental: this.querySelector('[data-serviced-rental-cost]'),
      savings: this.querySelector('[data-total-savings]'),
      savingsLabel: this.querySelector('[data-savings-label]'),
    };

    this.slider.removeEventListener('input', this.handleSliderInput);
    this.slider.removeEventListener('change', this.handleSliderInput);
    this.slider.addEventListener('input', this.handleSliderInput);
    this.slider.addEventListener('change', this.handleSliderInput);

    this.sync();
  }

  disconnectedCallback() {
    if (!(this.slider instanceof HTMLInputElement)) return;

    this.slider.removeEventListener('input', this.handleSliderInput);
    this.slider.removeEventListener('change', this.handleSliderInput);
  }

  handleSliderInput() {
    this.sync();
  }

  sync() {
    if (!(this.slider instanceof HTMLInputElement)) return;

    const weeklyBottles = Number(this.slider.value) || 0;
    const weeklyMin = Number(this.slider.min) || 1;
    const weeklyMax = Number(this.slider.max) || 15;
    const weeksPerMonth = Number(this.dataset.weeksPerMonth) || 4;
    const weeksPerQuarter = Number(this.dataset.weeksPerQuarter) || 13;
    const bottleCost = Number(this.dataset.bottleCost) || 14;
    const coolerRentalCost = Number(this.dataset.coolerRentalCost) || 45;
    const servicedRentalCost = Number(this.dataset.servicedRentalCost) || 185;

    const bottlesPerMonth = weeklyBottles * weeksPerMonth;
    const waterSupplyCost = weeklyBottles * weeksPerQuarter * bottleCost;
    const totalSystemCost = waterSupplyCost + coolerRentalCost;
    const savings = totalSystemCost - servicedRentalCost;
    const sliderProgress = ((weeklyBottles - weeklyMin) / (weeklyMax - weeklyMin)) * 100;

    this.style.setProperty('--slider-progress', `${sliderProgress}%`);
    this.slider.setAttribute('aria-valuetext', `${weeklyBottles} bottles per week`);

    if (this.outputs.weekly) this.outputs.weekly.textContent = String(weeklyBottles);
    if (this.outputs.monthly) this.outputs.monthly.textContent = String(bottlesPerMonth);
    if (this.outputs.waterSupply) this.outputs.waterSupply.textContent = this.formatCurrency(waterSupplyCost);
    if (this.outputs.coolerRental) this.outputs.coolerRental.textContent = this.formatCurrency(coolerRentalCost);
    if (this.outputs.totalSystem) this.outputs.totalSystem.textContent = this.formatCurrency(totalSystemCost);
    if (this.outputs.servicedRental) this.outputs.servicedRental.textContent = this.formatCurrency(servicedRentalCost);
    if (this.outputs.savings) this.outputs.savings.textContent = this.formatCurrency(Math.abs(savings));

    if (this.outputs.savingsLabel) {
      this.outputs.savingsLabel.textContent =
        savings >= 0
          ? this.dataset.savingsLabel || 'You Save'
          : this.dataset.negativeSavingsLabel || 'Extra cost';
    }

    this.dataset.savingsState = savings >= 0 ? 'positive' : 'negative';
  }

  formatCurrency(value) {
    const currencyCode = this.dataset.currencyCode || 'USD';
    const locale = document.documentElement.lang || 'en-US';

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    } catch (_error) {
      return `$${Number(value).toFixed(2)}`;
    }
  }
}

if (!customElements.get('water-cost-calculator')) {
  customElements.define('water-cost-calculator', WaterCostCalculator);
}
